export default function withFormatting(format, field) {
  return {
    ...field,
    serialize(value, params, options) {
      return field.serialize(format(value), params, options);
    }
  };
}
//# sourceMappingURL=with-formatting.js.map